module.exports = __webpack_public_path__ + "bf7032f01d5a1a7bec744f70d6772a2b.png";